module.exports = __webpack_public_path__ + "static/media/stop.04cc21c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/stop.svg
// module id = 823
// module chunks = 0